import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const LanguageSelector = ({ className = "", style = {} }) => {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState("mr");

  useEffect(() => {
    const saved = localStorage.getItem("app_lang") || "mr";
    setLang(saved);
  }, []);

  useEffect(() => {
    const current = (i18n.resolvedLanguage || i18n.language || "mr").split("-")[0];
    setLang(current);
  }, [i18n.resolvedLanguage, i18n.language]);

  const changeLang = async (lng) => {
    setLang(lng); // ✅ immediately update UI
    localStorage.setItem("app_lang", lng);
    localStorage.setItem("i18nextLng", lng); // ✅ also set this (safe)
    await i18n.changeLanguage(lng);
  };

  return (
    <div className={className} style={{ display: "flex", gap: 8, alignItems: "center", ...style }}>
      <span style={{ fontSize: 13 }}>{t("lang.label")}:</span>

      <select
        value={lang}
        onChange={(e) => changeLang(e.target.value)}
        style={{ padding: "4px 8px", borderRadius: 6 }}
      >
        <option value="mr">{t("lang.mr")}</option>
        <option value="en">{t("lang.en")}</option>
        <option value="hi">{t("lang.hi")}</option>
        <option value="kn">{t("lang.kn")}</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
